<pr-content-container
  matRipple
  class="h-full w-full cursor-pointer"
  height="h-full"
  (click)="clicked.emit(undefined)"
>
  <mat-radio-button
    disableRipple
    color="primary"
    [checked]="checked()"
    [value]="value()"
  >
    <ng-content />
  </mat-radio-button>
</pr-content-container>
